export const infoTexts = {
  // Landing Page & Summary Tab
  loanAmount: 'Original Loan Amount',
  productName: 'Product Type of the Loan',
  amountDueTillCurrent: 'Next Payment Amount as per the Contract',
  nextInstallmentDate: 'Date of the next Due',
  numberOfInstallments: 'Total Loan duration',
  availableAmountForNextFunding: 'Funds remaining to borrow',
  disbursedAmount: 'Funds utilized till date',
  nextPaymentDate: 'Date of the next payment due',
  nextPaymentAmount: 'Amount due for the next payment',

  // Summary Tab
  maturityDate: 'Loan End date',
  frequencyOfLoanPayment: 'Frequency of Bill generation',
  interestRate: 'Rate of Interest for the Loan',
  principalRemaining: 'Unpaid Loan Principal',
  interestRemaining: 'Unpaid interest till last accrual',
  additionalInterest: 'Additional Charges/Fees/Interest.',
  feesRemaining: 'Additional Charges/Fees/Interest.',
  status: 'Status of loan',
  totalOutstandingDueAmount: 'Sum of all unpaid Bills',
  totalOutstandingAsOfDate: 'Total unpaid Balance',

  // Payments
  // (Reusing totalOutstandingDueAmount and totalOutstandingAsOfDate)

  // Payoff Estimator
  payoffDate: 'Date of the estimated Payoff',
  payoffInterestRate: 'Current rate of interest on the Loan',
  payoffMaturityDate: 'Loan End date',
  principalOutstanding: 'Remaining unpaid Principal',
  payoffInterest: 'Interest part of Payoff Amount',
  totalPayoffAmount: 'Estimated Amount to close the loan.',
  feesCharges: 'Other unpaid Fees/charges.',
  prepaymentFees: 'Penalty for early closure',
}; 
